export const CreateSteambath = async (userToken, UseradminData) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${userToken}`);
  
      const requestBody = {
        member_id: UseradminData.member_id,
        total_bath: UseradminData.quantity,
        amount: UseradminData.amount,
      };
      if (UseradminData.payment_date) {
        requestBody.payment_date = UseradminData.payment_date;
      }
  
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
      };
  
      const response = await fetch(
        `${window.constants.api_url}/steam-bath/store`,
        requestOptions
      );
      const result = await response.json(); // Parse response as JSON
      return result;
    } catch (error) {
      throw new Error("Failed to create create-offer-package: " + error.message);
    }
  };

  export const UseSteambath = async (userToken, UseradminData) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${userToken}`);
  
      const requestBody = {
        member_id: UseradminData.member_id,
       
      };
  
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
      };
  
      const response = await fetch(
        `${window.constants.api_url}/use/steam-bath`,
        requestOptions
      );
      const result = await response.json(); // Parse response as JSON
      return result;
    } catch (error) {
      throw new Error("Failed to create create-offer-package: " + error.message);
    }
  };